<template>
  <div>
    <h1 class="ya-te-page-title mb-12 text-center font-bold leading-none md:mb-12">
      法人用お問い合わせ
    </h1>
    <div
      class="mb-7 border p-5"
      style="border-color: #f03;"
    >
      <h3 class="ya-te-text-red co-display-12 mb-4 text-center font-bold">
        新規お申し込み受付の一時停止について
      </h3>
      <p class="co-display-13 text-left">
        只今、新規のお申し込みを一時停止しております。再開に関するご案内は
        <a
          href="https://ly-academy.yahoo.co.jp/tech/index.html"
          target="_blank"
        >こちら</a>をご確認ください。<br>既にお申し込み済み・学習中のお客様は、原則引き続き受講・各種サポートをご利用いただけます。 ただし、一時停止を受け受講・各種サポート内容に影響があるお客様に対しては、事務局より個別にメールにてご連絡を差し上げます。
      </p>
      <p class="co-display-13 text-left">
        ※受講・サポート内容に影響のないお客様への個別連絡はございません。<br>これにともない、実施していた「2周年キャンペーン」も終了いたしました。
      </p>
    </div>
    <p class="mb-4 ml-4 text-center">
      <a
        href="/ly/terms-biz"
      >利用規約</a>及び<a
        href="/ly/privacypolicy-biz"
      >個人情報の取扱い</a>に同意の上、下記フォームに内容を記入し送信してください。
    </p>
    <p class="mb-4 ml-4 text-center">
      <img
        class="mx-auto"
        src="~/assets/images/YaTe/YaTeContactBiz/contact-biz.png"
        alt="法人用お問い合わせ"
        width="120"
        height="120"
      >
      LINEヤフーテックアカデミーの研修にご興味をお持ちくださり、
      <br>
      誠にありがとうございます。
      <br>
      <b>どんなことでもお気軽に、遠慮なくご相談ください。</b>
      <br>
      受講内容、人数、費用、内容など、
      <br>
      お客様からのご質問やご要望に真摯にお応えいたします。
    </p>
    <div class="mb-7 flex justify-center">
      <div class="co-display-13 bg-co-gray-200 p-4 text-co-gray-500 md:w-5/6">
        <h3 class="mb-2 font-bold leading-none">
          お問い合わせの前にご一読ください
        </h3>
        <p>
          お問い合わせ送信後、2営業日以内にご返信差し上げます。
          <br>
          営業時間：10:00～19:00（土日・祝祭日を除く）
        </p>
      </div>
    </div>
    <!-- フォーム -->
    <YaTeContactBizForm />
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'

import YaTeContactBizForm from '~/components/YaTe/YaTeContact/YaTeContactBizForm.vue'

const options = {
  async setup() {
    definePageMeta({
      layout: 'yate-side-menu'
    })
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'yahoo',
    })

    return {
      title: 'LINEヤフーテックアカデミーお問い合わせ | テックアカデミー',
      meta: [
        ...metaTags(
          {
            keywords:
              'プログラミング, ブートキャンプ, エンジニア, パーソナルメンター',
            description: 'LINEヤフーテックアカデミーのお問い合わせフォーム',
            twitterTitle:
              'LINEヤフーテックアカデミーお問い合わせ | テックアカデミー',
            twitterDescription:
              'LINEヤフーテックアカデミーのお問い合わせフォーム',
            twitterImage: '/_nuxt/ogp/yate/og-image.jpg',
            ogDescription: 'LINEヤフーテックアカデミーのお問い合わせフォーム',
            ogTitle:
              'LINEヤフーテックアカデミーお問い合わせ | テックアカデミー',
            ogUrl: '/yahoo/contact',
            ogImage: '/_nuxt/ogp/yate/og-image.jpg',
            noIndexNofollow: true,
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  components: {
    YaTeContactBizForm,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
@import url('~/assets/css/YaTe/YaTeCommon/YaTeCommon.css');
</style>
